import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import { AspectRatioWrapper } from 'fbk-components'
import { chunkify } from 'fbk-utils'
import { ArrowSlide as ArrowSlideIcon } from 'assets/svg'
import { theme } from 'theme'
import { SliderProps } from './types'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  margin-top: 12px;

  .prev-button,
  .next-button {
    position: absolute;
    top: calc(126px / 2 - 40px / 2);
    right: 0;
    z-index: 1;
    width: 40px;
    height: 40px;
    line-height: 0;
    background: #fff;
  }

  .prev-button {
    right: auto;
    left: 0;
    line-height: 0;
    transform: rotate(180deg);
  }

  @media (max-width: 1199px) {
    display: none;
  }
`

const CarouselWrapper = styled.div`
  width: 100%;
`
const OverflowWrapper = styled.div`
  overflow: hidden;
`

const Carousel = styled.div`
  position: relative;
  display: flex;
  transition: 0.2s ease-in-out;
`

const Images = styled.div`
  display: flex;
  min-width: 100%;
`

const CarouselItem = styled.div`
  width: 225px;
  cursor: pointer;
  ${({
    isLastSlideAndNotFull,
  }: {
    isLastSlideAndNotFull?: boolean
    isActive: boolean
  }) => {
    if (isLastSlideAndNotFull) {
      return css`
        margin-left: 20px;
      `
    }

    return css`
      margin-right: 20px;
    `
  }}

  &:last-child {
    margin-right: 0;
  }

  .image-item {
    ${({ isActive }) =>
      isActive
        ? css`
            background: linear-gradient(
              0deg,
              rgba(0, 0, 0, 0.7),
              rgba(0, 0, 0, 0.7)
            );
          `
        : null};
  }

  &:hover {
    .image-item {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7));
    }
  }
`

function NavCarousel({ images, activeSlide, setActiveSlide }: SliderProps) {
  const [slide, setSlide] = useState(0)
  const countSlideInChunk = 4
  let chunks: any[][] = chunkify(images, countSlideInChunk)
  const slideQty: number = chunks.length
  const lastSlideInChunks: any[] = chunks[chunks.length - 1]
  const countSlideInLastChunk: number = lastSlideInChunks.length
  const carouselWidth: number = +theme.contentWidth.desktop.replace('px', '')
  const carouselItemWidth: number = 245 // с учетом margin == 20px
  const isLastSlide: boolean = slide === slideQty - 1

  useEffect(() => {
    if (activeSlide === null) return

    const desiredSlide = Math.floor(activeSlide / countSlideInChunk)

    if (desiredSlide !== slide && activeSlide !== null) {
      setSlide(desiredSlide)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSlide])

  return (
    <Wrapper>
      {chunks.length > 1 && (
        <button
          className="prev-button"
          onClick={() => {
            setSlide(slide === 0 ? slideQty - 1 : slide - 1)
          }}
        >
          <ArrowSlideIcon />
        </button>
      )}
      <CarouselWrapper>
        <OverflowWrapper>
          <Carousel
            style={{
              transform: `translateX(-${
                isLastSlide && countSlideInLastChunk !== countSlideInChunk
                  ? (slide - 1) * carouselWidth +
                    carouselItemWidth * countSlideInLastChunk
                  : slide * carouselWidth
              }px)`,
            }}
          >
            {chunks.map((chunk, chunkIndex) => {
              const indexSlide = chunkIndex

              return (
                <Images
                  key={chunkIndex}
                  style={{
                    justifyContent: chunks.length > 1 ? 'flex-start' : 'center',
                  }}
                >
                  {chunk.map((url, index) => {
                    const currentSlide = index + indexSlide * countSlideInChunk

                    return (
                      <CarouselItem
                        isLastSlideAndNotFull={
                          countSlideInLastChunk !== countSlideInChunk &&
                          chunkIndex === slideQty - 1
                        }
                        key={index}
                        onClick={() => {
                          setActiveSlide(index + indexSlide * countSlideInChunk)
                        }}
                        isActive={currentSlide === activeSlide}
                      >
                        <AspectRatioWrapper aspectRatio="16 / 9">
                          <div
                            className="image"
                            style={{
                              backgroundImage: `url(${url})`,
                            }}
                          />

                          <div className="image-item" />
                        </AspectRatioWrapper>
                      </CarouselItem>
                    )
                  })}
                </Images>
              )
            })}
          </Carousel>
        </OverflowWrapper>
      </CarouselWrapper>
      {chunks.length > 1 && (
        <button
          className="next-button"
          onClick={() => {
            setSlide(slide === slideQty - 1 ? 0 : slide + 1)
          }}
        >
          <ArrowSlideIcon />
        </button>
      )}
    </Wrapper>
  )
}

export default NavCarousel
